@if (isLoaded | async) {
  <google-map
    ospMapDefaultOptions
    (mapInitialized)="mapInitialized.next($event)"
    [center]="center()"
    [zoom]="zoom"
    [height]="'100%'"
    [width]="'100%'"
  />
}
